import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Collection } from 'src/app/models/collection.interface';

@Component({
  selector: 'app-move-documents-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatFormFieldModule, MatSelectModule, MatButtonModule],
  template: `
    <h1 mat-dialog-title>Move Documents</h1>
    <div mat-dialog-content>
      <p>Select a destination collection:</p>
      <mat-form-field>
        <mat-label>Destination Collection</mat-label>
        <mat-select [(value)]="selectedCollectionId">
          <mat-option *ngFor="let collection of data.collections" [value]="collection.collection_id">
            {{ collection.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [mat-dialog-close]="selectedCollectionId" cdkFocusInitial>Move</button>
    </div>
  `
})
export class MoveDocumentsDialogComponent {
  selectedCollectionId = '';

  constructor(
    public dialogRef: MatDialogRef<MoveDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { collections: Collection[] }
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
